import { menuRegistry } from '@/common/menu/menuRegistry';
import { registerRouteForModule } from '@/common/route/registerModules';
import router, { ROUTE_NAME_PROGRESS } from './router';

menuRegistry.registerMenu([
    {
        parent: 'Multiplayer',
        key: 'Progress',
        name: 'Progress',
        icon: 'far fa-calendar-check'
    },
    {
        parent: 'Multiplayer.Progress',
        key: 'Item',
        name: 'Item',
        icon: 'fas fa-leaf',
        route: { name: ROUTE_NAME_PROGRESS.ITEM.INDEX }
    },
    {
        parent: 'Multiplayer.Progress',
        key: 'Promotion',
        name: 'Promotion',
        icon: 'fas fa-percentage',
        route: { name: ROUTE_NAME_PROGRESS.PROMOTION.INDEX }
    }
]);

export default registerRouteForModule(router);
